module.exports = __webpack_public_path__ + "static/media/go.249bf814.png";